module.exports = "/img/upload_fail.94ee6df2.png";